import _get from 'lodash/get'

export const modalTitle = '友情提示'
export const SUCCESS = 'SUCCESS'
export const FAILURE = 'FAILURE'
export const REQUEST = 'REQUEST'
export const ERROR_UNAUTHORIZED = 'ERROR_UNAUTHORIZED'
export const ERROR_TIMEOUT = '遭遇系统异常，请重试'
export const pageSize = 10
export const globalConst = {
  doLoadJsConfig: 'doLoadJsConfig',
  loadServerUrl: 'loadServerUrl',
  downLoad: 'downLoad',
  listFile: 'listFile',
  readBlock: 'readBlock',
  readEncryption: 'readEncryption',
  readSerial: 'readSerial',
  readBeforeThreeBit: 'readBeforeThreeBit',
  writeBlock: 'writeBlock',
  rename: 'rename',
  queryDownLoadProcess: 'queryDownLoadProcess',
  delFile: 'delFile',
  resList: 'resList',
  resListAll: 'resListAll',
  resTypeList: 'resTypeList',
  resDetail: 'resDetail',
  resSearch: 'resSearch',
  installPack: 'installPack',
  doBindDevice: 'doBindDevice',
  loadDeviceList: 'loadDeviceList',
  addDevice: 'addDevice',
  updateDevice: 'updateDevice',
  changeDevice: 'changeDevice',
  getDevice: 'getDevice',
  getVersion: 'getVersion',
  softwareUpdate: 'softwareUpdate',
  softwareUpdateProcess: 'softwareUpdateProcess',
  reboot: 'reboot',
  delDevice: 'delDevice',
  loadNowVersion: 'loadNowVersion'
}
export const methods = [SUCCESS.toLowerCase(), FAILURE.toLowerCase(), REQUEST.toLowerCase()]
const mutationNames = {}
for (let actionName in globalConst) {
  if (globalConst.hasOwnProperty(actionName)) {
    methods.forEach((method) => {
      if (!mutationNames[`${actionName}_${method}`]) {
        mutationNames[`${actionName}_${method}`] = `${actionName}_${method}`
      }
    })
  }
}
export {
  mutationNames
}
export const LOAD_NO = 0
export const LOAD_ING = 1
export const LOAD_COMPLATE = 2
export const modulesName = {
  common: 'common',
  auth: 'auth',
  downLoader: 'downLoader',
  package: 'package',
  device: 'device'
}

export function noop () {

}

export const sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop(),
  set: noop()
}

export function getVuexState (moduleName, path, defaultValue) {
  if (!Array.isArray(path)) {
    path = [path]
  }
  return function (store) {
    return _get(store, [moduleName, ...path], defaultValue)
  }
}

export function createVuexErrorState (moduleList) {
  moduleList.forEach((module) => {
    let state = module.state
    let copyState = Object.assign({}, state)
    for (let s in copyState) {
      if (copyState.hasOwnProperty(s)) {
        state[`${s}_loading`] = false
        state[`${s}_error`] = null
      }
    }
  })
}

export const downLoaderErrorMsg = {
  0: 'ok',
  1: '下载方式错误',
  2: 'url格式不正确',
  3: '目录不正确',
  4: '回调异常',
  5: '请求头异常',
  6: '下载名称格式异常',
  7: '下载中...',
  8: '点读笔读取异常',
  9: '未识别到点读笔',
  10: '点读笔读取异常',
  11: '读取目录错误',
  12: '下载失败',
  13: '下载超时',
  14: '数据异常',
  15: '数据异常',
  16: '读取列表信息异常',
  17: '读取数据信息异常',
  18: '读取数据异常',
  19: '写入数据异常',
  20: '写入数据失败',
  21: '数据异常',
  22: '数据异常',
  23: '没有下载',
  24: '下载进程异常',
  25: '重命名失败',
  26: '该文件不存在',
  27: '获取设备信息异常',
  28: '获取设备信息异常',
  29: '删除文件失败',
  30: 'wifi扫描异常',
  31: 'wifi扫描异常',
  32: 'wifi扫描异常',
  33: 'wifi设置失败',
  34: '更新异常',
  35: '连接服务器失败',
  36: '获取软件版本信息错误',
  37: '软件更新异常',
  38: '软件更新超时',
  39: '软件更新异常',
  40: '软件更新异常',
  41: '软件更新异常',
  42: '软件更新异常',
  43: '软件更新异常',
  44: '软件更新异常',
  45: '软件更新异常',
  46: '软件更新异常',
  47: '软件更新异常',
  48: '软件更新异常',
  49: '软件更新异常',
  50: '软件更新中...'
}
// 资源类型 0：未分配，1：直接点读 2 智能点读 3贴纸点读
export const RES_TYPE_ZHIJIEDIANDU = 1
export const RES_TYPE_ZHINENGDIANDU = 2
export const RES_TYPE_TIEZHIDIANDU = 3
export const resTypeMap = {
  [RES_TYPE_ZHIJIEDIANDU]: '直接点读',
  [RES_TYPE_ZHINENGDIANDU]: '智能点读',
  [RES_TYPE_TIEZHIDIANDU]: '贴纸点读'
}